export default __webpack_public_path__ + "static/media/kuchnia5.1ac03b3b.jpg";